(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glowverse-signup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('glowverse-signup');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const teaser = document.querySelector('.gv-signup__teaser');
    const form = dialog.querySelector('form');
    const key = 'itgirl-glowverse';
    const read = (storage, name) => { try { return window[storage].getItem(name); } catch { return null; } };
    const write = (storage, name, value) => { try { window[storage].setItem(name, value); } catch {} };
    let previousOverflow = '';
    let returnFocus = null;
    let timer;
    const submitted = read('sessionStorage', key + '-pending') === 'yes';
    const success = submitted && dialog.querySelector('[data-gv-success]');
    const failed = submitted && dialog.querySelector('[data-gv-error]');
    const open = () => {
      if (dialog.open) return;
      returnFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      teaser.hidden = true;
      dialog.querySelector('.gv-signup__close').focus({ preventScroll: true });
    };
    const close = () => { clearTimeout(timer); dialog.close(); };
    dialog.querySelector('.gv-signup__close').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      write('localStorage', key + '-dismissed', String(Date.now()));
      teaser.hidden = read('localStorage', key + '-subscribed') === 'yes';
      if (returnFocus instanceof HTMLElement && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
    });
    teaser.addEventListener('click', open);
    form.addEventListener('submit', () => write('sessionStorage', key + '-pending', 'yes'));
    if (success) {
      write('localStorage', key + '-subscribed', 'yes');
      write('sessionStorage', key + '-pending', '');
      open();
      dialog.querySelector('[data-gv-success]').focus({ preventScroll: true });
    } else if (failed) {
      open();
    } else if (read('localStorage', key + '-subscribed') !== 'yes') {
      const dismissed = Number(read('localStorage', key + '-dismissed')) || 0;
      if (Date.now() - dismissed > 7 * 24 * 60 * 60 * 1000) timer = setTimeout(open, 5000);
      else teaser.hidden = false;
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
